const Knee_questions = [
  {
    question: "How is ##name## being evaluated today?",
    sub: "",
    type: "radio",
    telehealth:
      "form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "",
    },
    questions: [
      {
        label: "How was the examination conducted?",
        title: "",
        subMain: "",
        sub: "",
        radioGroup:
          "form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
        options: [
          {
            main: "In-Person Exam",
            dbqName: "1",
            sub: "",
          },
          {
            main: "Video Telehealth",
            dbqName: "2",
            sub: "",
          },
        ],
        answer: "In-Person Exam",
      },
    ],
  },
  {
    question: "Is ##name## regularly seen as a patient in your clinic?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "",
    },
    presidence: "Yes",
    radioGroup:
      "form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
    ref: 0,
    dbqName_yes: "1",
    dbqName_no: "2",
    answer: "",
  },
  {
    question: "Did you review any of the patients records for this condition?",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "1",
      title: "Disability Benefits Questionnaire",
      number: "",
    },
    presidence: "Yes",
    radioGroup:
      "form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
    ref: 0,
    dbqName_yes: "2",
    dbqName_no: "1",
    answer: "",
    istext: true,
    textarea: false,
    placeholder: "Please identify the evidence reviewed and the date range",
    textdbqName:
      "form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
    textanswer: "",
  },
  {
    question: "Initial Range of Motion (ROM) Measurements",
    redHeading: "Right Knee",
    sub: "",
    type: "text",
    show: true,
    section: {
      page: "4",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    questions: [
      {
        main: "Flexion",
        subMain: "Normal Endpoint is 140 Degrees",
        sub: "Post-Test ROM Measurement",
        type: "select",
        dbqName: "form1[0].#subform[6].TextField6[105]",
        defaultVal: "140",
        clearDefaultOnNormalize: true,
        placeholder: "Select flexion",
        values: [
          "140",
          "135",
          "130",
          "125",
          "120",
          "115",
          "110",
          "105",
          "100",
          "95",
          "90",
          "85",
          "80",
          "75",
          "70",
          "65",
          "60",
          "55",
          "50",
          "45",
          "40",
          "35",
          "30",
          "25",
          "20",
          "15",
          "10",
          "5",
          "0",
        ],
        answer: "140",
      },
      {
        main: "Extension",
        subMain: "Normal Endpoint is 0 Degrees",
        sub: "Post-Test ROM Measurement",
        type: "select",
        dbqName: "form1[0].#subform[6].TextField6[106]",
        defaultVal: "0",
        clearDefaultOnNormalize: true,
        placeholder: "Select extension",
        disabledPlaceholder: "Select flexion first",
        dependsOnOptionIndex: 0,
        valueFilter: "belowSelected",
        values: [
          "140",
          "135",
          "130",
          "125",
          "120",
          "115",
          "110",
          "105",
          "100",
          "95",
          "90",
          "85",
          "80",
          "75",
          "70",
          "65",
          "60",
          "55",
          "50",
          "45",
          "40",
          "35",
          "30",
          "25",
          "20",
          "15",
          "10",
          "5",
          "0",
        ],
        answer: "0",
      },
    ],
  },
  {
    question: "Initial Range of Motion (ROM) Measurements",
    redHeading: "Left Knee",
    sub: "",
    type: "text",
    show: true,
    questions: [
      {
        main: "Flexion",
        subMain: "Normal Endpoint is 140 Degrees",
        sub: "Post-Test ROM Measurement",
        type: "select",
        dbqName: "form1[0].#subform[6].TextField6[108]",
        defaultVal: "140",
        clearDefaultOnNormalize: true,
        placeholder: "Select flexion",
        values: [
          "140",
          "135",
          "130",
          "125",
          "120",
          "115",
          "110",
          "105",
          "100",
          "95",
          "90",
          "85",
          "80",
          "75",
          "70",
          "65",
          "60",
          "55",
          "50",
          "45",
          "40",
          "35",
          "30",
          "25",
          "20",
          "15",
          "10",
          "5",
          "0",
        ],
        answer: "140",
      },
      {
        main: "Extension",
        subMain: "Normal Endpoint is 0 Degrees",
        sub: "Post-Test ROM Measurement",
        type: "select",
        dbqName: "form1[0].#subform[6].TextField6[109]",
        defaultVal: "0",
        clearDefaultOnNormalize: true,
        placeholder: "Select extension",
        disabledPlaceholder: "Select flexion first",
        dependsOnOptionIndex: 0,
        valueFilter: "belowSelected",
        values: [
          "140",
          "135",
          "130",
          "125",
          "120",
          "115",
          "110",
          "105",
          "100",
          "95",
          "90",
          "85",
          "80",
          "75",
          "70",
          "65",
          "60",
          "55",
          "50",
          "45",
          "40",
          "35",
          "30",
          "25",
          "20",
          "15",
          "10",
          "5",
          "0",
        ],
        answer: "0",
      },
    ],
  },
  {
    question: "Which ROM exhibited pain? ",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    show: true,
    small: true,
    partial: true,
    cols: 2,
    section: {
      page: "4",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    questions: [
      {
        main: "Right Flexion",
        dbqName: "form1[0].#subform[6].CheckBox37[20]",
        answer: "",
      },
      {
        main: "Left Flexion",
        dbqName: "form1[0].#subform[6].CheckBox37[37]",
        answer: "",
      },
      {
        main: "Right Extension",
        dbqName: "form1[0].#subform[6].CheckBox37[21]",
        answer: "",
      },
      {
        main: "Left Extension",
        dbqName: "form1[0].#subform[6].CheckBox37[38]",
        answer: "",
      },
      {
        main: "None",
        dbqName: "pass_this_question",
        partialField: true,
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there evidence of pain for ##redHeading##?",
    redHeading: "Right Knee",
    sub: "",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "4",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    // this question contains right YES dbqName for question 3A: can testing be performed
    questions: [
      {
        main: "Weight-bearing",
        dbqName:
          "form1[0].#subform[6].CheckBox37[24],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "Non-weight bearing",
        dbqName:
          "form1[0].#subform[6].CheckBox37[25],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "Active motion",
        dbqName:
          "form1[0].#subform[6].CheckBox37[27],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "Passive motion",
        dbqName:
          "form1[0].#subform[6].CheckBox37[26],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "On Rest/Non-movement",
        dbqName:
          "form1[0].#subform[6].CheckBox37[28],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "Causes functional loss",
        dbqName:
          "form1[0].#subform[6].CheckBox37[29],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
        textarea: true,
        textdbqName: "form1[0].#subform[6].TextField6[107]",
        placeholder: "describe in the functional loss",
        textAnswer: "",
      },
      {
        main: "Does not result in/cause functional loss",
        dbqName:
          "form1[0].#subform[6].CheckBox37[30],form1[0].#subform[6].#area[42].CheckBox37[35]",
        answer: "",
      },
      {
        main: "None",
        partialField: true,
        dbqName: "form1[0].#subform[6].#area[42].CheckBox37[36]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there evidence of pain for ##redHeading##?",
    redHeading: "Left Knee",
    sub: "",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "4",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    // this question contains left YES dbqName for question 3A: can testing be performed
    questions: [
      {
        main: "Weight-bearing",
        dbqName:
          "form1[0].#subform[6].CheckBox37[43],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "Non-weight bearing",
        dbqName:
          "form1[0].#subform[6].CheckBox37[44],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "Active motion",
        dbqName:
          "form1[0].#subform[6].CheckBox37[46],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "Passive motion",
        dbqName:
          "form1[0].#subform[6].CheckBox37[45],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "On Rest/Non-movement",
        dbqName:
          "form1[0].#subform[6].CheckBox37[47],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "Causes functional loss",
        dbqName:
          "form1[0].#subform[6].CheckBox37[48],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
        textarea: true,
        textdbqName: "form1[0].#subform[6].TextField6[112]",
        placeholder: "describe in the functional loss",
        textAnswer: "",
      },
      {
        main: "Does not result in/cause functional loss",
        dbqName:
          "form1[0].#subform[6].CheckBox37[49],form1[0].#subform[6].#area[43].CheckBox37[52]",
        answer: "",
      },
      {
        main: "None",
        partialField: true,
        dbqName: "form1[0].#subform[6].#area[43].CheckBox37[53]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there objective evidence of crepitus?",
    sub: "",
    type: "radio",
    show: true,
    section: {
      page: "5",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    questions: [
      {
        label: "Right Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[7].#area[46].CheckBox37[58]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[7].#area[46].CheckBox37[59]",
            sub: "",
          },
        ],
        answer: "No",
      },
      {
        label: "Left Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[7].#area[49].CheckBox37[66]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[7].#area[49].CheckBox37[67]",
            sub: "",
          },
        ],
        answer: "No",
      },
    ],
  },
  {
    question:
      "Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
    redHeading: "Right Knee",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "5",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "form1[0].#subform[7].#area[48].CheckBox37[64]",
    dbqName_no: "form1[0].#subform[7].#area[48].CheckBox37[65]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please explain. Include location, severity, and relationship to condition(s)",
    textdbqName: "form1[0].#subform[7].TextField6[128]",
    textanswer: "",
  },
  {
    question:
      "Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
    redHeading: "Left Knee",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "5",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "3A",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "form1[0].#subform[7].#area[55].CheckBox37[108]",
    dbqName_no: "form1[0].#subform[7].#area[55].CheckBox37[109]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please explain. Include location, severity, and relationship to condition(s)",
    textdbqName: "form1[0].#subform[7].TextField6[127]",
    textanswer: "",
  },
  {
    question: "Is there recurrent subluxation or persistent instability?",
    sub: "",
    type: "radio",
    show: true,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6A",
    },
    questions: [
      {
        label: "Right Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[9].#area[65].CheckBox37[150]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[65].CheckBox37[151]",
            sub: "",
          },
        ],
        answer: "No",
      },
      {
        label: "Left Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[9].#area[72].CheckBox37[175]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[72].CheckBox37[176]",
            sub: "",
          },
        ],
        answer: "No",
      },
    ],
  },
  {
    question: "Is there or has there been a ligament tear (sprain)?",
    sub: "",
    type: "radio",
    show: true,
    multi: true,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6B",
    },
    questions: [
      {
        label: "Right Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Complete ligament tear",
            dbqName:
              "form1[0].#subform[9].CheckBox37[154],form1[0].#subform[9].#area[66].CheckBox37[152]",
            sub: "",
          },
          {
            main: "Incomplete/partial ligament tear",
            dbqName:
              "form1[0].#subform[9].CheckBox37[155],form1[0].#subform[9].#area[66].CheckBox37[152]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[66].CheckBox37[153]",
            sub: "",
          },
        ],
        answer: "No",
      },
      {
        label: "Left Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Complete ligament tear",
            dbqName:
              "form1[0].#subform[9].CheckBox37[179],form1[0].#subform[9].#area[73].CheckBox37[177]",
            sub: "",
          },
          {
            main: "Incomplete or partial ligament tear",
            dbqName:
              "form1[0].#subform[9].CheckBox37[180],form1[0].#subform[9].#area[73].CheckBox37[177]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[73].CheckBox37[178]",
            sub: "",
          },
        ],
        answer: "No",
      },
    ],
  },
  {
    question: "Was the ligament tear repaired?",
    sub: "",
    type: "radio",
    show: true,
    multi: true,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6C",
    },
    questions: [
      {
        label: "Right Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Complete tear repair- Successful",
            dbqName:
              "form1[0].#subform[9].CheckBox37[158],form1[0].#subform[9].#area[67].CheckBox37[156]",
            sub: "",
          },
          {
            main: "Complete tear repair- Failed",
            dbqName:
              "form1[0].#subform[9].CheckBox37[159],form1[0].#subform[9].#area[67].CheckBox37[156]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[67].CheckBox37[157]",
            sub: "",
          },
        ],
        answer: "No",
      },
      {
        label: "Left Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Complete tear repair- Successful",
            dbqName:
              "form1[0].#subform[9].CheckBox37[183],form1[0].#subform[9].#area[74].CheckBox37[181]",
            sub: "",
          },
          {
            main: "Complete tear repair- Failed",
            dbqName:
              "form1[0].#subform[9].CheckBox37[184],form1[0].#subform[9].#area[74].CheckBox37[181]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[74].CheckBox37[182]",
            sub: "",
          },
        ],
        answer: "No",
      },
    ],
  },
  {
    question:
      "Does ##name## require a prescription (by a medical provider) of any of the following for ambulation for ##redHeading##?",
    redHeading: "Right Knee",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6D",
    },
    questions: [
      {
        main: "Cane(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[164],form1[0].#subform[9].#area[70].CheckBox37[171]",
        answer: "",
      },
      {
        main: "Walker",
        dbqName:
          "form1[0].#subform[9].CheckBox37[165],form1[0].#subform[9].#area[70].CheckBox37[171]",
        answer: "",
      },
      {
        main: "Crutches",
        dbqName:
          "form1[0].#subform[9].CheckBox37[163],form1[0].#subform[9].#area[70].CheckBox37[171]",
        answer: "",
      },
      {
        main: "Brace(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[166],form1[0].#subform[9].#area[70].CheckBox37[171]",
        answer: "",
      },
      {
        main: "No",
        partialField: true,
        dbqName: "form1[0].#subform[9].#area[70].CheckBox37[172]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## require a prescription (by a medical provider) of any of the following for ambulation for ##redHeading##?",
    redHeading: "Left Knee",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6D",
    },
    questions: [
      {
        main: "Cane(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[189],form1[0].#subform[9].#area[76].CheckBox37[194]",
        answer: "",
      },
      {
        main: "Walker",
        dbqName:
          "form1[0].#subform[9].CheckBox37[190],form1[0].#subform[9].#area[76].CheckBox37[194]",
        answer: "",
      },
      {
        main: "Crutches",
        dbqName:
          "form1[0].#subform[9].CheckBox37[188],form1[0].#subform[9].#area[76].CheckBox37[194]",
        answer: "",
      },
      {
        main: "Brace(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[191],form1[0].#subform[9].#area[76].CheckBox37[194]",
        answer: "",
      },
      {
        main: "No",
        partialField: true,
        dbqName: "form1[0].#subform[9].#area[76].CheckBox37[195]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question: "Is there recurrent patellar instability?",
    sub: "",
    type: "radio",
    show: true,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6E",
    },
    questions: [
      {
        label: "Right Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[9].#area[68].CheckBox37[167]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[68].CheckBox37[168]",
            sub: "",
          },
        ],
        answer: "No",
      },
      {
        label: "Left Knee",
        title: "",
        subMain: "",
        sub: "",
        options: [
          {
            main: "Yes",
            dbqName: "form1[0].#subform[9].#area[75].CheckBox37[192]",
            sub: "",
          },
          {
            main: "No",
            dbqName: "form1[0].#subform[9].#area[75].CheckBox37[193]",
            sub: "",
          },
        ],
        answer: "No",
      },
    ],
  },
  {
    question:
      "Has ##name## had surgical repair of the knee for patellar instability for ##redHeading##?",
    redHeading: "Right Knee",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "6F",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "form1[0].#subform[9].#area[64].CheckBox37[148]",
    dbqName_no: "form1[0].#subform[9].#area[64].CheckBox37[149]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please explain. Include location, severity, and relationship to condition(s)",
    textdbqName: "form1[0].#subform[9].TextField6[165]",
    textanswer: "",
  },
  {
    question:
      "Has ##name## had surgical repair of the knee for patellar instability for ##redHeading##?",
    redHeading: "Left Knee",
    sub: "",
    type: "yesno",
    show: true,
    section: {
      page: "7",
      title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
      number: "6F",
    },
    presidence: "Yes",
    ref: 0,
    dbqName_yes: "form1[0].#subform[9].#area[71].CheckBox37[173]",
    dbqName_no: "form1[0].#subform[9].#area[71].CheckBox37[174]",
    answer: "",
    istext: true,
    textarea: false,
    placeholder:
      "Please explain. Include location, severity, and relationship to condition(s)",
    textdbqName: "form1[0].#subform[9].TextField6[166]",
    textanswer: "",
  },
  {
    question:
      "Does ##name## require a prescription (by a medical provider) of any of the following for ambulation with patellar instability for ##redHeading##?",
    redHeading: "Right Knee",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6G",
    },
    questions: [
      {
        main: "Cane(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[160],form1[0].#subform[9].#area[69].CheckBox37[169]",
        answer: "",
      },
      {
        main: "Walker",
        dbqName:
          "form1[0].#subform[9].CheckBox37[161],form1[0].#subform[9].#area[69].CheckBox37[169]",
        answer: "",
      },
      {
        main: "Crutches",
        dbqName:
          "form1[0].#subform[9].CheckBox37[162],form1[0].#subform[9].#area[69].CheckBox37[169]",
        answer: "",
      },
      {
        main: "Brace(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[198],form1[0].#subform[9].#area[69].CheckBox37[169]",
        answer: "",
      },
      {
        main: "No",
        partialField: true,
        dbqName: "form1[0].#subform[9].#area[69].CheckBox37[170]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Does ##name## require a prescription (by a medical provider) of any of the following for ambulation with patellar instability for ##redHeading##?",
    redHeading: "Left Knee",
    sub: "Check all that apply",
    type: "radioTiles",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "7",
      title: "JOINT STABILITY",
      number: "6G",
    },
    questions: [
      {
        main: "Cane(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[185],form1[0].#subform[9].#area[77].CheckBox37[196]",
        answer: "",
      },
      {
        main: "Walker",
        dbqName:
          "form1[0].#subform[9].CheckBox37[186],form1[0].#subform[9].#area[77].CheckBox37[196]",
        answer: "",
      },
      {
        main: "Crutches",
        dbqName:
          "form1[0].#subform[9].CheckBox37[187],form1[0].#subform[9].#area[77].CheckBox37[196]",
        answer: "",
      },
      {
        main: "Brace(s)",
        dbqName:
          "form1[0].#subform[9].CheckBox37[199],form1[0].#subform[9].#area[77].CheckBox37[196]",
        answer: "",
      },
      {
        main: "No",
        partialField: true,
        dbqName: "form1[0].#subform[9].#area[77].CheckBox37[197]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Shin Splints (medial tibial stress syndrome - MTSS) for the ##redHeading##",
    redHeading: "Right Knee",
    sub: "Indicate all treatment and symptoms below",
    type: "radioTiles",
    multi: true,
    show: true,
    partial: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "TIBIAL OR FIBULAR IMPAIRMENT",
      number: "7A",
    },
    questions: [
      {
        main: "Treatment for less than 12 consecutive months",
        dbqName:
          "form1[0].#subform[10].CheckBox37[208],form1[0].#subform[10].CheckBox36[200],form1[0].#subform[10].#area[82].CheckBox37[228]",
        answer: "",
      },
      {
        main: "Unresponsive to shoe orthotics or other conservative treatment",
        dbqName:
          "form1[0].#subform[10].CheckBox37[210],form1[0].#subform[10].CheckBox36[200],form1[0].#subform[10].#area[82].CheckBox37[228]",
        answer: "",
      },
      {
        main: "Requiring treatment for 12 consecutive months or more",
        dbqName:
          "form1[0].#subform[10].CheckBox37[209],form1[0].#subform[10].CheckBox36[200],form1[0].#subform[10].#area[82].CheckBox37[228]",
        answer: "",
      },
      {
        main: "Responsive to surgery",
        dbqName:
          "form1[0].#subform[10].CheckBox37[238],form1[0].#subform[10].CheckBox36[200],form1[0].#subform[10].#area[82].CheckBox37[228]",
        answer: "",
      },
      {
        main: "Unresponsive to surgery",
        dbqName:
          "form1[0].#subform[10].CheckBox37[211],form1[0].#subform[10].CheckBox36[200],form1[0].#subform[10].#area[82].CheckBox37[228]",
        answer: "",
      },
      {
        main: "None",
        partialField: true,
        dbqName: "form1[0].#subform[10].#area[82].CheckBox37[229]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Shin Splints (medial tibial stress syndrome - MTSS) for the ##redHeading##",
    redHeading: "Left Knee",
    sub: "Indicate all treatment and symptoms below",
    type: "radioTiles",
    multi: true,
    show: true,
    partial: true,
    small: true,
    cols: 2,
    section: {
      page: "8",
      title: "TIBIAL OR FIBULAR IMPAIRMENT",
      number: "7A",
    },
    questions: [
      {
        main: "Treatment for less than 12 consecutive months",
        dbqName:
          "form1[0].#subform[10].CheckBox37[212],form1[0].#subform[10].CheckBox36[204],form1[0].#subform[10].#area[83].CheckBox37[230]",
        answer: "",
      },
      {
        main: "Unresponsive to shoe orthotics or other conservative treatment",
        dbqName:
          "form1[0].#subform[10].CheckBox37[214],form1[0].#subform[10].CheckBox36[204],form1[0].#subform[10].#area[83].CheckBox37[230]",
        answer: "",
      },
      {
        main: "Requiring treatment for 12 consecutive months or more",
        dbqName:
          "form1[0].#subform[10].CheckBox37[213],form1[0].#subform[10].CheckBox36[204],form1[0].#subform[10].#area[83].CheckBox37[230]",
        answer: "",
      },
      {
        main: "Responsive to surgery",
        dbqName:
          "form1[0].#subform[10].CheckBox37[239],form1[0].#subform[10].CheckBox36[204],form1[0].#subform[10].#area[83].CheckBox37[230]",
        answer: "",
      },
      {
        main: "Unresponsive to surgery",
        dbqName:
          "form1[0].#subform[10].CheckBox37[215],form1[0].#subform[10].CheckBox36[204],form1[0].#subform[10].#area[83].CheckBox37[230]",
        answer: "",
      },
      {
        main: "None",
        partialField: true,
        dbqName: "form1[0].#subform[10].#area[83].CheckBox37[231]",
        answer: "",
      },
    ],
    answer: "",
  },

  {
    question:
      "Has ##name## been diagnosed with a  meniscus (semilunar cartilage) condition for ##redHeading##?",
    redHeading: "Right knee",
    sub: "",
    type: "yesno",
    show: true,
    multi: true,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    presidence: "Yes",
    ref: 2,
    dbqName_yes: "form1[0].#subform[10].#area[84].CheckBox37[232]",
    dbqName_no:
      "form1[0].#subform[10].#area[84].CheckBox37[233],form1[0].#subform[10].CheckBox37[216]",
    answer: "",
  },
  {
    question: "Meniscus (semilunar cartilage) condition for ##redHeading##",
    redHeading: "Right knee",
    sub: "Indicate severity and frequency of symptoms",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    partial: true,
    cols: 2,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    questions: [
      // {
      //    "main":"No current symptoms",
      //    "partialField": true,
      //    "dbqName":"form1[0].#subform[10].CheckBox37[216]",
      //    "answer":""
      // },
      {
        main: "Meniscal dislocation",
        dbqName: "form1[0].#subform[10].CheckBox37[217]",
        answer: "",
      },
      {
        main: "Meniscal tear",
        dbqName: "form1[0].#subform[10].CheckBox37[218]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint locking",
        dbqName: "form1[0].#subform[10].CheckBox37[219]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint pain",
        dbqName: "form1[0].#subform[10].CheckBox37[220]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint effusion",
        dbqName: "form1[0].#subform[10].CheckBox37[221]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Please describe about all symptoms checked on previous screen for ##redHeading##",
    redHeading: "Right knee",
    sub: "",
    optional: true,
    type: "textarea",
    show: false,
    refId: 2,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    options: [],
    dbqName: "form1[0].#subform[10].TextField6[173]",
    answer: "",
  },

  {
    question:
      "Has ##name## been diagnosed with a  meniscus (semilunar cartilage) condition for ##redHeading##?",
    redHeading: "Left knee",
    sub: "",
    type: "yesno",
    show: true,
    multi: true,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    presidence: "Yes",
    ref: 2,
    dbqName_yes: "form1[0].#subform[10].#area[85].CheckBox37[234]",
    dbqName_no:
      "form1[0].#subform[10].#area[85].CheckBox37[235],form1[0].#subform[10].CheckBox37[222]",
    answer: "",
  },
  {
    question: "Meniscus (semilunar cartilage) condition for ##redHeading##",
    redHeading: "Left knee",
    sub: "Indicate severity and frequency of symptoms",
    type: "radioTiles",
    multi: true,
    show: false,
    refId: 1,
    small: true,
    partial: true,
    cols: 2,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    questions: [
      // {
      //   main: "No current symptoms",
      //   partialField: true,
      //   dbqName:
      //     "form1[0].#subform[10].CheckBox37[222],form1[0].#subform[10].#area[85].CheckBox37[234]",
      //   answer: "",
      // },
      {
        main: "Meniscal dislocation",
        dbqName: "form1[0].#subform[10].CheckBox37[223]",
        answer: "",
      },
      {
        main: "Meniscal tear",
        dbqName: "form1[0].#subform[10].CheckBox37[224]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint locking",
        dbqName: "form1[0].#subform[10].CheckBox37[225]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint pain",
        dbqName: "form1[0].#subform[10].CheckBox37[226]",
        answer: "",
      },
      {
        main: "Frequent episodes of joint effusion",
        dbqName: "form1[0].#subform[10].CheckBox37[227]",
        answer: "",
      },
    ],
    answer: "",
  },
  {
    question:
      "Please describe about all symptoms checked on previous screen for ##redHeading##",
    redHeading: "Left knee",
    sub: "",
    optional: true,
    type: "textarea",
    show: false,
    refId: 2,
    section: {
      page: "8",
      title: "MENISCAL CONDITIONS",
      number: "8A",
    },
    options: [],
    dbqName: "form1[0].#subform[10].TextField6[174]",
    answer: "",
  },

  {
    question:
      "Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
    redHeading: "Right knee",
    sub: "",
    type: "radioModal",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "9",
      title: "SURGICAL PROCEDURES",
      number: "9A",
    },
    questions: [
      {
        main: "No surgery",
        dbqName: "form1[0].#subform[10].CheckBox37[240]",
        partialField: true,
        answer: "",
      },
      {
        main: "Knee joint resurfacing",
        dbqName: "form1[0].#subform[10].CheckBox37[242]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[10].TextField6[175]",
      },
      {
        main: "Total knee joint replacement",
        dbqName: "form1[0].#subform[10].CheckBox37[241]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[10].TextField6[176]",
        subItems: [
          {
            main: "None",
            dbqName: "form1[0].#subform[10].CheckBox37[243]",
            colWidth: 3,
            answer: "",
          },
          {
            main: "Intermediate degrees of residual weakness, pain, or limitation of motion",
            dbqName: "form1[0].#subform[10].CheckBox37[244]",
            colWidth: 9,
            answer: "",
          },
          {
            main: "Other",
            dbqName: "form1[0].#subform[11].CheckBox37[265]",
            colWidth: 3,
            subItemLinked: true,
            answer: "",
          },
          {
            main: "Chronic residuals consisting of severe painful motion or weakness",
            dbqName: "form1[0].#subform[10].CheckBox37[236]",
            colWidth: 9,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Residuals",
        subItemOther: false,
        textOther: "",
        dbqNameOther: "form1[0].#subform[11].TextField6[188]",
        placeholderOther: "Other residuals describe",
      },
      {
        main: "Meniscectomy",
        dbqName: "form1[0].#subform[11].CheckBox37[250]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[192]",
      },
      {
        main: "Arthroscopic ligament repair",
        dbqName: "form1[0].#subform[11].CheckBox37[267]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[191]",
      },
      {
        main: "Other surgery",
        dbqName: "form1[0].#subform[11].CheckBox37[268]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "form1[0].#subform[11].TextField6[181]",
        placeholder1: "Type of surgery",
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[190]",
      },
      {
        main: "Residual signs of symptoms due to meniscectomy, arthroscopic ligament repair or other knee surgery",
        dbqName: "form1[0].#subform[11].CheckBox37[251]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "form1[0].#subform[11].TextField6[182]",
        placeholder1: "Type of surgery",
      },
    ],
    answer: "",
  },
  {
    question:
      "Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
    redHeading: "Left knee",
    sub: "",
    type: "radioModal",
    multi: true,
    partial: true,
    show: true,
    small: true,
    cols: 2,
    section: {
      page: "9",
      title: "SURGICAL PROCEDURES",
      number: "9A",
    },
    questions: [
      {
        main: "No surgery",
        dbqName: "form1[0].#subform[10].CheckBox37[245]",
        partialField: true,
        answer: "",
      },
      {
        main: "Knee joint resurfacing",
        dbqName: "form1[0].#subform[10].CheckBox37[247]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[10].TextField6[178]",
      },
      {
        main: "Total knee joint replacement",
        dbqName: "form1[0].#subform[10].CheckBox37[246]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[10].TextField6[179]",
        subItems: [
          {
            main: "None",
            dbqName: "form1[0].#subform[10].CheckBox37[248]",
            colWidth: 3,
            answer: "",
          },
          {
            main: "Intermediate degrees of residual weakness, pain, or limitation of motion",
            dbqName: "form1[0].#subform[10].CheckBox37[249]",
            colWidth: 9,
            answer: "",
          },
          {
            main: "Other",
            dbqName: "form1[0].#subform[11].CheckBox37[266]",
            colWidth: 3,
            subItemLinked: true,
            answer: "",
          },
          {
            main: "Chronic residuals consisting of severe painful motion or weakness",
            dbqName: "form1[0].#subform[10].CheckBox37[237]",
            colWidth: 9,
            answer: "",
          },
        ],
        subAnswer: "",
        subItemsLabel: "Residuals",
        subItemOther: false,
        textOther: "",
        dbqNameOther: "form1[0].#subform[11].TextField6[189]",
        placeholderOther: "Other residuals describe",
      },
      {
        main: "Meniscectomy",
        dbqName: "form1[0].#subform[11].CheckBox37[269]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[195]",
      },
      {
        main: "Arthroscopic ligament repair",
        dbqName: "form1[0].#subform[11].CheckBox37[270]",
        answer: "",
        multi: false,
        showSubItems: false,
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[194]",
      },
      {
        main: "Other surgery",
        dbqName: "form1[0].#subform[11].CheckBox37[271]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "form1[0].#subform[11].TextField6[184]",
        placeholder1: "Type of surgery",
        date1: "",
        dbqDate1: "form1[0].#subform[11].TextField6[193]",
      },
      {
        main: "Residual signs of symptoms due to meniscectomy, arthroscopic ligament repair or other knee surgery",
        dbqName: "form1[0].#subform[11].CheckBox37[252]",
        answer: "",
        multi: false,
        showSubItems: false,
        text1: "",
        dbqName1: "form1[0].#subform[11].TextField6[185]",
        placeholder1: "Type of surgery",
      },
    ],
    answer: "",
  },

  {
    question: "Additional Comments",
    sub: "",
    optional: true,
    type: "textarea",
    show: true,
    section: {
      page: "10",
      title: "REMARKS",
      number: "15A",
    },
    options: [],
    dbqName: "form1[0].#subform[12].TextField6[198]",
    answer: "",
  },
];

export default Knee_questions;
